import {useEffect} from 'react';

import {useHBStore} from 'hb-redux-store/root.hooks.js';
import {
  getAllMembershipDetail,
  addMembershipTocart,
  removeMembershipTocart,
} from 'hb-redux-store/feature/halalboxPrime/hbPrime.action';
import {selectHBPrimeData} from 'hb-redux-store/feature/halalboxPrime/hbPrime.selectors';

export const useHBPrimeData = (shouldFetch = false) => {
  const {state, dispatch} = useHBStore();
  const hbPrimeStore = selectHBPrimeData(state);

  useEffect(() => {
    if (shouldFetch) dispatch(getAllMembershipDetail());
  }, [shouldFetch]);

  return {
    hbPrimeStore,
    addMembershipTocart: payload => dispatch(addMembershipTocart(payload)),
    removeMembershipTocart: payload =>
      dispatch(removeMembershipTocart(payload)),
  };
};
